import { Component, Prop, Vue } from 'vue-property-decorator';
import { merge, set } from 'lodash';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

export enum EAcquisitionModule {
  Standard = 'standard',
  Vionic = 'vionic',
  RunningTreadmill = 'running-treadmill',
  RunningOutdoor = 'running-outdoor',
}

@Component
class MixinAcquisitionStepBase extends Vue {
  @Prop({ required: true }) protected completed!: boolean;
  @Prop({ required: true }) protected payload!: any;

  protected error: typeof Error | null = null;
}

@Component
export default class MixinAcquisitionStep<TData> extends MixinAcquisitionStepBase {
  @Prop({ required: true }) protected patientId!: TEntity<TPatient>['_id'];
  @Prop({ required: true }) protected acquisitionModule!: EAcquisitionModule;
  @Prop({ required: false, default: null }) protected commandResumed!: any | null;

  protected pending: boolean = true;

  /**
   * Get parent key (the name of the step)
   */
  get key() {
    return (this.$options as any)._parentVnode.key;
  }

  /**
   * Extract step data from payload
   */
  get stepData(): TData {
    return this.payload[this.key];
  }

  get aqStepDetails() {
    return this.$store.state.pdc.acquisition.stepDetails;
  }

  /**
   * Patch "completed" flag
   * @param state
   */
  patchCompletedFlag(state: boolean) {
    this.$pdc.bus!.emitDebug('acquisition:step-patch-completed', this.key, state);
  }

  /**
   * Patch "data" state
   * @param data
   */
  patchDataState(data: TData) {
    this.$pdc.bus!.emitDebug('acquisition:step-patch-data', this.key, data);
  }

  /**
   * Helper to patch data with object path
   * @param path
   * @param data
   */
  pathToState(path: string, data: any) {
    this.patchDataState(merge(this.stepData, set({}, path, data)));
  }
}

@Component
export class MixinAcquisitionStepSlot extends MixinAcquisitionStepBase {
  @Prop({ required: true }) protected name!: string;

  get stepData() {
    return this.payload[this.name];
  }
}
